import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_197fd05f: FaireBrandEntity = {
  token: "b_197fd05f",
  type: "brand",
  name: "Pinch Provisions",
  avatarUrl:
    "https://cdn.faire.com/fastly/5772309560d1deafa5f94adefe4b949c4c83a572f8deb5401d984808e1ac3cfb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/61f632ca25696195524d231d294aba93ebd17dcb56fc05afb11ffc3ca4b731aa.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5772309560d1deafa5f94adefe4b949c4c83a572f8deb5401d984808e1ac3cfb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/61f632ca25696195524d231d294aba93ebd17dcb56fc05afb11ffc3ca4b731aa.jpeg",
  location: "Elk Grove Village, IL, USA",
  minimumOrderDollars: 137,
  rating: 5,
  reviewCount: 227,
  isTopShop: true,
  isInsider: true,
  description:
    "Pinch Provisions began as a pioneer in the personal care category, crafting innovative emergency kits that redefine what it means to be prepared in a pinch.® Since 2004, this female-founded company has pushed the boundaries of personal care, combining the sensibility of a fashion label with the function of a modern general store. Twenty years later, Pinch Provisions has grown to include a full range of lifestyle kits and solution-oriented accessories. As a leader in the gift industry with millions of kits sold, Pinch is a design-led, quality obsessed brand that its fans are proud to give and thrilled to carry.\n",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:44:59.249Z",
    importedBy: "entity-db-cli",
  },
};
